import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const SearchSubtypeMaster = withSuspense(lazy(() => import('./deal-subtype-master-search')));
export default SearchSubtypeMaster;
